<mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="nom-tree">
    <!-- This is the tree node template for leaf nodes -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
        <li class="mat-tree-node row">
            <div class="col-auto tree-node-name">{{node.name}}</div>
            <div class="edit-btns col-auto">
                <button class="btn btn-sm btn-primary mr-3">Edit</button>
                <button class="btn btn-sm btn-primary">History</button>
            </div>
        </li>
    </mat-tree-node>
    <!-- This is the tree node template for expandable nodes -->
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <li>
            <div class="mat-tree-node">
                <a matTreeNodeToggle
                   [attr.aria-label]="'toggle ' + node.name">
                    <i class="fa {{treeControl.isExpanded(node) ? 'fa-chevron-down' : 'fa-chevron-right'}}">
                    </i>
                </a>
                {{node.name}}<a href="javascript:void(0);" class="add-plus">
                <i class="fa {{treeControl.isExpanded(node) ? 'fa-plus-circle fa-sm' : ''}}"></i></a>
            </div>
            <ul [class.nom-tree-invisible]="!treeControl.isExpanded(node)">
                <ng-container matTreeNodeOutlet></ng-container>
                <li class="row">
                    <div class="form-group col-md-3 col-lg-2 mb-lg-0">
                        <app-panel-input placeholder="Name"></app-panel-input>
                    </div>
                    <div class="form-group col-md-3 col-lg-2 mb-lg-0">
                        <app-select placeholder="Status"></app-select>
                    </div>
                    <div class="form-group col-md-3 col-lg-2 mb-lg-0">
                        <app-select placeholder="Status"></app-select>
                    </div>

                    <div class="col-auto btn-row">
                        <button class="btn btn-sm btn-primary mr-3">Save</button>
                        <button class="btn btn-sm btn-primary">Cancel</button>
                    </div>
                </li>
            </ul>
        </li>
    </mat-nested-tree-node>
</mat-tree>
